import * as R from 'ramda';
import { OrderProduct, Section } from '../../orderProducts.types';
import OrderProductsBuilder, { OrderProductsGroupProps } from './OrderProductsGroupBuilder';

class OrderProductsGroupByCollection extends OrderProductsBuilder {
  public group({ orderProducts }: OrderProductsGroupProps): Section[] {
    const groupedProducts = R.groupBy<OrderProduct>(
      (product) => product.collection?.name || '',
      orderProducts,
    );

    const groupedProductsToPairs = R.toPairs(groupedProducts);

    return groupedProductsToPairs.map((items) => {
      const products = items[1]!;
      return {
        collection: products[0].collection,
        productsCount: products.length,
        isExpanded: true,
        products,
      };
    });
  }
}

export default OrderProductsGroupByCollection;
